import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'
import router from './router'
import { createPinia } from 'pinia'
import 'flag-icon-css/css/flag-icons.min.css'
import { app as firebaseApp } from '@/plugins/firebase' // Ensure firebase is initialized
import 'flowbite'
import i18n from './i18n/index'
import '@fontsource/baloo-2'
import '@fontsource/caveat/700.css'

// Import the listener initializer function
import { initializeAuthListener } from '@/stores/users' // Adjust path if needed

const app = createApp(App)

app.use(createPinia()) // Initialize Pinia first

// Initialize the persistent Firebase Auth listener ONCE
initializeAuthListener()

app.use(i18n)
app.use(router) // Use router AFTER Pinia and listener init
app.config.globalProperties.$firebaseApp = firebaseApp

// Mount after router is ready, ensures async guards can resolve
router.isReady().then(() => {
  app.mount('#app')
})
